import { useUISize } from 'app/utils/web-helpers';
import { CredentialsScreen as CredentialsScreenSmall } from './credentials.small';
import { CredentialsScreen as CredentialsScreenLarge } from './credentials.large';

export {
  CredentialsFormFields,
  type CredentialsFormFieldsProps,
  type OnboardingNavigationHeaderPresentation,
  useOnboardingNavigation,
} from './credentials.shared';

export const CredentialsScreen: typeof CredentialsScreenSmall = (props) => {
  const { isSmallUI } = useUISize();
  if (isSmallUI) {
    return <CredentialsScreenSmall {...props} />;
  }
  return <CredentialsScreenLarge {...props} />;
};
